import { publishQueries } from '@/entities/sets/publish';
import { commonQueries, usePersistStore } from '@/shared/lib/store';
import { Modal } from '@/shared/ui';
import { PodPreview } from '@/widgets/pod';
import { PodHeader } from '@/widgets/section-header';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';

// LEGACY(POD1): 기존 발행물의 직접 미리보기 URL 호환을 위해 유지합니다.
export const Route = createFileRoute('/sets/pod/re-preview/$publishId')({
    component: RouteComponent,
    loader: ({ params }) => {
        return { publishId: Number(params.publishId) };
    },
});

function RouteComponent() {
    const router = useRouter();
    const { publishId } = Route.useLoaderData();
    const { sUserId } = usePersistStore();
    const wsRef = useRef<WebSocket | null>(null);

    const [articleIdList, setArticleIdList] = useState<{ id: string }[]>([]);
    const [queryData, setQueryData] = useState<DATA.WsQueryDataType>();
    const [examList, setExamList] = useState<{ value: string; label: string }[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data } = publishQueries.detail.getPublishDetail(
        { publishId: publishId!, wrterId: sUserId },
        !!publishId && !!sUserId,
        false
    );

    const { mutate } = commonQueries.postLesnRscSetSummaryList();

    const getArticleList = (setId: string) => {
        mutate(
            {
                set_ids: [setId?.toString().split('examId')[0]!],
                orderby_col: 'id',
                orderby_dir: 'asc',
                limit_page: '1',
                limit_pageItemCnt: 9999,
            },
            {
                onSuccess: (res) => {
                    if (res.status === 200) {
                        setArticleIdList(
                            res.data.vo[0].setSummary.map((e) => ({ id: e.article_id }))
                        );
                    }
                },
            }
        );
    };

    useEffect(() => {
        if (data && data?.publishInfoDetail) {
            getArticleList(data?.publishInfoDetail.setsId);
            setExamList([
                {
                    value:
                        data?.publishInfoDetail?.setsId?.toString() +
                        'examId' +
                        data?.publishInfoDetail?.examId,
                    label: data?.publishInfoDetail?.publishNm,
                },
            ]);
        }
    }, [data]);

    useEffect(() => {
        if (data && data?.publishInfoDetail && articleIdList?.length > 0) {
            const legacy = data?.publishInfoDetail.podOptionList;
            data?.publishInfoDetail.podOptionList.map((e) => {
                return;
            });
            const newCheckList = [];
            if (legacy.find((item) => item.code === 'pod_answer')?.val === 'Y') {
                newCheckList.push('pod_answer');
            }
            if (legacy.find((item) => item.code === 'pod_description')?.val === 'Y') {
                newCheckList.push('pod_description');
            }
            if (legacy.find((item) => item.code === 'pod_eng_description')?.val === 'Y') {
                newCheckList.push('pod_eng_description');
            }
            const uniqueItems =
                Array.from(new Map(articleIdList?.map((item) => [item.id, item]))?.values()) ?? '';
            const newData = {
                request: 'pdf',
                target: data?.publishInfoDetail?.curriSchoolVal.replace('학교', '') ?? '',
                header: {
                    template:
                        legacy.find((item) => item.code === 'pod_template')?.val ??
                        'pod_template_01',
                    title: data?.publishInfoDetail?.publishNm ?? '',
                    subject: data?.publishInfoDetail?.curriSubjectVal ?? '',
                    class:
                        (data?.publishInfoDetail?.curriGradeVal &&
                        data?.publishInfoDetail?.curriGradeVal !== '학년 정보 없음'
                            ? data?.publishInfoDetail?.curriGradeVal
                            : '') +
                        ' ' +
                        (data?.publishInfoDetail?.curriSemesterVal &&
                        data?.publishInfoDetail?.curriSemesterVal !== '학기 정보 없음'
                            ? data?.publishInfoDetail?.curriSemesterVal
                            : ''),
                },
                answer: legacy.find((item) => item.code === 'pod_answer')?.val ?? 'Y',
                description: legacy.find((item) => item.code === 'pod_description')?.val ?? 'Y',
                eng_description:
                    legacy.find((item) => item.code === 'pod_eng_description')?.val ?? 'Y',
                qr: 'N',
                letter:
                    legacy.find((item) => item.code === 'pod_letter')?.val.split('_')[2] ?? 'A4',
                section:
                    legacy.find((item) => item.code === 'pod_section')?.val.split('_')[2] === '1'
                        ? '1'
                        : '2_' +
                          legacy.find((item) => item.code === 'pod_section')?.val.split('_')[3],
                articles: uniqueItems ?? '',
                mebmerId: sUserId,
            };
            setQueryData(newData);
        }
    }, [data, articleIdList]);

    const backUrl = '/sets/pod';
    const backSearch = { publishId: Number(publishId) };
    const exitUrl = '/sets/published-box/detail/' + publishId;
    return (
        <>
            <Modal
                open={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false);
                    router.history.back();
                }}
                title="안내"
                description="접근 권한이 없습니다. 본인이 발행한 시험지에만 접근할 수 있습니다."
            />
            <PodHeader
                type={'detail'}
                queryData={queryData!}
                backUrl={backUrl}
                backSearch={backSearch}
                exitUrl={exitUrl}
                wsRef={wsRef}
            />
            <PodPreview
                queryData={queryData!}
                examList={examList}
                wsRef={wsRef}
                selectExam={examList[0]}
                publishData={data}
            />
        </>
    );
}
